import React, { useEffect } from "react";
import classes from "./aboutUs.module.css";
import Footer from "../../components/footer";

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <div className={classes.aboutContainer}>
        <h1>About Us – Artist Next Door</h1>
        <p className={classes.txt}>
          Ever struggled to find the right performer for your event? Or as an
          artist, felt like you’re waiting for the right break?
          <strong> Artist Next Door</strong> is here to change that. 🎭🎶
        </p>
        <p className={classes.txt}>
          We’re not just a platform—we’re a community where artists and event
          organizers come together effortlessly. Whether you're a singer,
          musician, magician, or performer, we make sure your talent gets the
          stage it deserves. And if you're looking for an artist, we've got the
          perfect match, minus the hassle of agents and middlemen.
        </p>
        <p className={classes.txt}>
          From last-minute gigs to planned performances, we’re here to make
          booking seamless and discovering talent effortless. Because at{" "}
          <strong>Artist Next Door</strong>, it's not just about events—it’s
          about experiences. Join the movement. Let’s create something
          unforgettable! ✨
        </p>
      </div>
      <Footer />
    </>
  );
};

export default AboutUs;
